<div class="downloads-grid__searchbox-container">
  @if (isUploadUser) {
    <button
      (click)="showFileManager(null);"
      class="downloads-grid__upload-button"
      >Upload
    File</button>
  }
  <input type="text" placeholder="&#xf002;  {{'main.tabs.downloads.search' | translate}}"
    (input)="onSearchInput(input.value)" class="form-control downloads-grid__search-box" #input>
</div>
@if (files) {
  <rdo-grid-table-ng
    #grid
    [name]="gridName"
    [gridConfig]="gridConfig"
    [pagedData]="files"
    [sorting]="sorting"
    [(paging)]="paging"
    (pageOnChange)="changePage($event)"
    [scrollScale]="'largeScale'"
    (lazyLoadOnChange)="changeLazyLoad($event)"
    [totalCount]="totalCount"
    [frozenWidth]="'100%'"
    [showColumnSelector]="false"
    [alwaysShowPager]="true"
    [fixedScrollableHeight]="'41vh'"
    [paginatorClass]="'downloads-grid__paginator'"
    />
}
<div [class.hidden]="isloading">
  <rdo-overlay [enabled]="isloading"></rdo-overlay>
</div>
